import { useEffect, useState } from 'react';
const getInitialInnerHeight = () => {
    var _a;
    const documentHeight = ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || window.innerHeight;
    if (documentHeight == 0) {
        return;
    }
    return documentHeight;
};
const useInnerHeight = () => {
    const [currentInnerHeight, setCurrentInnerHeight] = useState(getInitialInnerHeight());
    const getCurrentInnerHeight = () => {
        var _a;
        const documentHeight = ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || window.innerHeight;
        if (documentHeight == 0) {
            return;
        }
        return documentHeight;
    };
    const handleResize = () => {
        const currentIw = getCurrentInnerHeight();
        if (currentIw && currentIw !== currentInnerHeight) {
            setCurrentInnerHeight(currentIw);
        }
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });
    return currentInnerHeight;
};
export default useInnerHeight;
